import studentViewSelector from './student_view_selector'
import studentSessionDataSelector from './student_session_data_selector'
import studentSessionTypeSelector from './student_session_type_selector'
import pollSubmitSelector from './poll_submit_selector'
import pollSlideSelector from './poll_slide_selector'
import quizSubmitSelector from './quiz_submit_selector'
import quizSlideSelector from './quiz_slide_selector'
import oeqSubmitSelector from './oeq_submit_selector'
import oeqSlideSelector from './oeq_slide_selector'
import matchingPairsSlideSelector from './matching_pairs_slide_selector'
import drawItSlideSelector from './draw_it_slide_selector'
import drawItSubmitSelector from './draw_it_submit_selector'
import slideDataSelector from './slide_data_selector'
import studentAudioSelector from './student_audio_selector'
import oeqSubmissionReadySelector from './oeq_submit_ready_selector'
import leadSubmitSelector from './lead_submit_selector'
import leadSlideSelector from './lead_slide_selector'
import readOnlySlideSelector from './read_only_slide_selector'

export default {
	studentViewSelector,
	studentSessionDataSelector,
	studentSessionTypeSelector,
	pollSubmitSelector,
	pollSlideSelector,
	quizSubmitSelector,
	quizSlideSelector,
	oeqSubmitSelector,
	oeqSlideSelector,
	matchingPairsSlideSelector,
	drawItSlideSelector,
	drawItSubmitSelector,
	slideDataSelector,
	studentAudioSelector,
	oeqSubmissionReadySelector,
	leadSubmitSelector,
	leadSlideSelector,
	readOnlySlideSelector,
}
